import { Fade } from "@mui/material";
import PropTypes from "prop-types";

const AlertMessageBox = ({ message, status = "success" }) => {
  const stylesByStatus = {
    success: {
      bg: "#ecfdf5",
      color: "#065f46",
      icon: "✔",
    },
    error: {
      bg: "#fef2f2",
      color: "#991b1b",
      icon: "✗",
    },
    loading: {
      bg: "#fefce8",
      color: "#854d0e",
      icon: "⏳",
    },
  };
  const style = stylesByStatus[status] || stylesByStatus.success;

  return (
    <Fade in={!!message}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          padding: "6px 12px",
          backgroundColor: style.bg,
          color: style.color,
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 500,
          transition: "all 0.2s ease-in-out",
          maxWidth: "360px",
        }}
      >
        <span style={{ fontSize: "16px" }}>{style.icon}</span>
        <span>{message}</span>
      </div>
    </Fade>
  );
};

AlertMessageBox.propTypes = {
  message: PropTypes.string,
  isError: PropTypes.bool,
  color: PropTypes.string,
};

export default AlertMessageBox;
